/* global I18n */

import React, {useState} from "react"
import FaIcon from "../fa_icon"
import ToggleSwitch from "./toggle_switch"

function ExpandableControls({title, checked, onChange, children}) {
  const [section_expanded, set_section_expanded] = useState(false)

  function toggle_expand() {
    set_section_expanded(!section_expanded)
  }

  return (
    <div className="group-item expandable">
      <div className="content">
        <div className="info">
          <p className="description">
            {title}
          </p>
        </div>
        <div className="control">
          <button
            className={`edit-button ${section_expanded ? "active" : ""}`}
            onClick={toggle_expand}
          >
            {I18n.t("js.quiz_mode_selector.muscle_facts.edit")}
            <FaIcon name={"fa-chevron-down"}/>
          </button>
          <ToggleSwitch
            checked={checked}
            onChange={onChange}
          />
        </div>
      </div>
      {section_expanded &&
        <div className="expandable-area">
          {children}
        </div>}
    </div>)
}

export default ExpandableControls
